// DS1.6.10
import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import s from './BetaBadge.scss';
var BetaBadge = function (_a) {
    var badgeType = _a.badgeType, variant = _a.variant, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement("div", { className: c(className, s['root'], variant === 'small' && s['small'], variant === 'medium' && s['medium']) }, t("betaBadge.label.var." + badgeType)));
};
BetaBadge.displayName = 'BetaBadge';
export default BetaBadge;
//# sourceMappingURL=BetaBadge.js.map